<template>
  <div class="container">
    <div class="final-container">
      <div class="left">
        <vue-intervencija
          v-bind="$props"
          v-if="current_step === 8"
          @set-status-data="$emit('set-status-data', $event)"
          @confirm-step="$emit('confirm-step', $event)"
          @back-step="$emit('back-step', $event)"
        ></vue-intervencija>
        <vue-materijal
          v-bind="$props"
          v-if="current_step === 9"
          @confirm-step="$emit('confirm-step', $event)"
          @back-step="$emit('back-step', $event)"
        ></vue-materijal>
        <vue-next
          v-bind="$props"
          v-if="current_step === 10 || current_step === 12"
          :current_step="current_step"
          @confirm-step="$emit('confirm-step', $event)"
          @back-step="$emit('back-step', $event)"
        ></vue-next>
        <vue-list v-bind="$props" v-if="current_step === 13" @navigate="$emit('navigate', $event)"></vue-list>
      </div>
      <div class="right">
        <div class="title">{{ uppercase(main_data.calc_savings_desktop.title) }}</div>
        <div class="eur">
          {{
            app_math.numberWithCommas(get_final_calculation.existing.cena - get_final_calculation.new.cena)
          }}&nbsp;<span v-html="main_data.currency.value" />
        </div>
        <div class="energy">
          {{
            app_math.numberWithCommas(
              settings.show_potrebno
                ? get_final_calculation.existing.final - get_final_calculation.new.final
                : get_final_calculation.existing.final_grejanje - get_final_calculation.new.final_grejanje
            )
          }}&nbsp;kWh
        </div>
        <div class="spacer"></div>
        <div class="subtitle">{{ uppercase(main_data.calc_uporedno.title) }}</div>
        <div class="row row-1">
          <div class="row-title"></div>
          <div class="row-existing stanje">
            <div class="stanje-left existing">
              <img src="../../assets/images/desktop/stikla_bela.svg" alt="" />
            </div>
            <div class="stanje-right">
              {{ uppercase(main_data.calc_existing.title) }}
            </div>
          </div>
          <div class="row-new stanje">
            <div class="stanje-left">
              <img src="../../assets/images/desktop/dupla_stikla_bela_outlined.svg" alt="" />
            </div>
            <div class="stanje-right">
              {{ uppercase(main_data.calc_advanced.title) }}
            </div>
          </div>
        </div>
        <template v-for="(row_type, index) in main_data.calc_order.value.split(';')">
          <div v-if="row_type === 'E'" :class="['row', 'row-2', index === 0 ? 'row-first' : '']" :key="row_type">
            <div class="row-title">
              <img :src="getCurrencyIconUrl()" alt="" />
            </div>
            <div class="row-existing">
              {{ app_math.numberWithCommas(get_final_calculation.existing.cena) }}
            </div>
            <div class="row-new">{{ app_math.numberWithCommas(get_final_calculation.new.cena) }}</div>
          </div>
          <div v-if="row_type === 'C'" :class="['row', 'row-3', index === 0 ? 'row-first' : '']" :key="row_type">
            <div class="row-title">
              <img src="../../assets/images/desktop/co2_ikonica.svg" alt="" />
            </div>
            <div class="row-existing">{{ app_math.numberWithCommas(get_final_calculation.existing.co2) }}</div>
            <div class="row-new">{{ app_math.numberWithCommas(get_final_calculation.new.co2) }}</div>
          </div>
          <div v-if="row_type === 'H'" :class="['row', 'row-4', index === 0 ? 'row-first' : '']" :key="row_type">
            <div class="row-title">
              <img src="../../assets/images/desktop/grejanje_ikonica.svg" alt="" />
            </div>
            <div class="row-existing">
              {{
                app_math.numberWithCommas(
                  settings.show_potrebno
                    ? get_final_calculation.existing.final
                    : get_final_calculation.existing.final_grejanje
                )
              }}
            </div>
            <div class="row-new">
              {{
                app_math.numberWithCommas(
                  settings.show_potrebno ? get_final_calculation.new.final : get_final_calculation.new.final_grejanje
                )
              }}
            </div>
          </div>
        </template>

        <div class="spacer"></div>
        <div class="final">
          <div class="final-left">
            <form target="_blank" method="GET" :action="calc_cta" id="myForm">
              <input type="hidden" name="json" :value="getJson" />
              <input
                :disabled="!ponuda"
                type="submit"
                :class="{ button: true, active: ponuda }"
                :value="uppercase(main_data.calc_offer.title)"
                :style="{ fontSize: ctaFontSize /* u zavisnosti od drzave */ }"
              />
            </form>
          </div>
          <div class="final-right" @click="startAgain">
            <div class="reload-left">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 29.998 34.48">
                <g>
                  <path
                    fill="currentColor"
                    d="M-185.51 70.823A15.086 15.086 0 0 0-172.261 57.6a15.094 15.094 0 0 0-14.805-16.841V36.7a.291.291 0 0 0-.472-.2l-8.354 6.135a.257.257 0 0 0 0 .416l8.354 6.135a.293.293 0 0 0 .472-.2v-4.05A10.935 10.935 0 0 1-176.34 56.6a10.979 10.979 0 0 1-10.192 10.157 10.938 10.938 0 0 1-11.494-9.157 2.081 2.081 0 0 0-2.057-1.74 2.063 2.063 0 0 0-2.05 2.367 15.1 15.1 0 0 0 16.623 12.596z"
                    transform="translate(202.158 -36.439)"
                  />
                </g>
              </svg>
            </div>
            <div class="reload-right">{{ main_data.calc_again_desktop.title }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.container {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;

  .final-container {
    width: 94.7rem;
    display: flex;
    justify-content: space-between;
    text-align: center;
    color: $text_white;
    align-items: center;

    .left {
      width: 42rem;
    }

    .right {
      width: 48rem;

      .title {
        font-family: F-Dem;
        font-size: 2.4rem;
        margin-bottom: 1rem;
        color: $desktop_button_text_inactive;
      }

      .eur {
        font-size: 7.2rem;
        font-weight: 900;
        line-height: 1.32;
        margin-bottom: 1rem;
      }

      .energy {
        font-family: F-Dem;
        font-size: 3rem;
        line-height: 1.33;
        color: $calc_back;
        margin-bottom: 1.5rem;
      }

      .spacer {
        height: 1.5rem;
        border-bottom: 1px solid $main_header_light;
      }

      .subtitle {
        margin: 1.6rem 0 2.4rem 0;
        font-family: F-Dem;
        font-size: 1.8rem;
        line-height: 1;
        color: $desktop_button_text_inactive;
      }

      .row {
        display: flex;
        height: 6.5rem;
        margin-bottom: 0.8rem;
        font-size: 2.4rem;
        font-family: F-Dem;

        &.row-1 {
          height: 3.5rem;
          margin-bottom: 1rem;

          .stanje {
            margin: auto;
            display: flex;
            font-size: 1.4rem;
            line-height: 1.21;
            text-align: left;

            .stanje-left {
              width: 3.5rem;

              &.existing {
                width: 2.5rem;
              }

              img {
                width: 100%;
                max-width: 100%;
              }
            }

            .stanje-right {
              margin-left: 0.7rem;
            }
          }
        }

        &.row-2 {
          .row-existing {
            background-image: linear-gradient(to top, #2db46a, #1f5d70);
          }

          .row-new {
            background-color: $desktop_green;
          }
        }

        &.row-3 {
          .row-existing {
            background-image: linear-gradient(to top, #919191, #1f5d70);
          }

          .row-new {
            background-color: $calc_gray;
          }
        }

        &.row-first {
          height: 11.5rem;

          .row-title {
            height: 6.5rem;
            align-self: center;
          }
        }

        &.row-4 {
          .row-existing {
            background-image: linear-gradient(to top, #f05a28, #1f5d70);
          }

          .row-new {
            background-color: $calc_back;
          }
        }

        &.row-5 {
          margin-top: 1.5rem;
          height: 7.2rem;
          font-size: 2.1rem;
          font-family: F-Std;
          font-weight: normal;
          text-align: left;

          .row-title {
            padding-right: 1rem;
          }

          .en-class {
            position: relative;

            svg {
              max-height: 100%;
              height: 100%;
              position: absolute;
              left: 0;
            }

            img {
              position: absolute;
              height: 4, 2rem;
              max-height: 4.2rem;
              left: 1rem;
              top: 1.5rem;
              width: auto;
              z-index: 1;
            }
          }
        }

        &.row-6 {
          font-size: 1.3rem;
          font-weight: normal;
          line-height: 1.15;
          font-family: F-Std;
          color: $desktop_button_text_inactive;
          height: auto;
          margin-top: 1.5rem;

          .row-existing {
            width: 38rem;
            justify-content: flex-start;
            text-align: left;
          }
        }

        .row-existing {
          width: 19rem;
          display: flex;
          justify-content: center;
          align-items: center;
          flex-shrink: 0;
        }

        .row-new {
          width: 19rem;
          display: flex;
          justify-content: center;
          align-items: center;
          flex-shrink: 0;
        }

        .row-title {
          flex-grow: 1;
          display: flex;
          justify-content: center;
          align-items: center;

          img {
            width: 90%;
            max-width: 90%;
            height: 80%;
            max-height: 80%;
            object-fit: contain;
          }
        }
      }

      .final {
        display: flex;
        flex-direction: column;

        .final-left {
          .button {
            margin: 2.4rem auto 0 auto;
            height: 6.9rem;
            width: 100%;
            background-color: $desktop_button_inactive;
            border-radius: 3.45rem;
            font-size: 2.4rem;
            display: flex;
            justify-content: center;
            align-items: center;
            color: $main_header_light;
            appearance: none;
            border: none;
            padding: 0;

            &.active {
              background-color: $calc_back;
              color: $text_white;
              cursor: pointer;
            }
          }
        }

        .final-right {
          justify-content: center;
          display: flex;
          margin-top: 2.4rem;
          height: 4rem;
          cursor: pointer;

          .reload-left {
            flex: 0 0 5.4rem;
            color: $desktop_button_text_inactive;

            svg {
              width: 3rem;
            }
          }

          .reload-right {
            margin-left: 1.3rem;
            font-size: 2.1rem;
            line-height: 1;
            text-align: left;
            color: $desktop_button_text_inactive;
          }
        }

        .final-right:hover {
          .reload-left {
            color: $calc_back;
          }

          .reload-right {
            color: $text_white;
          }
        }
      }
    }
  }
}
</style>

<script>
import app_math from "../../lib/math.js";
import mixin from "../../lib/mixins.js";
import intervencija from "./desktop_intervencija.vue";
import materijal from "./desktop_materijal.vue";
import next from "./desktop_next.vue";
import list from "./desktop_list.vue";
import settings from "../../Settings.js";

export default {
  props: [
    "main_data",
    "get_final_calculation",
    "ponuda",
    "current_step",
    "current_position",
    "get_sklopovi_data",
    "get_loc_u_max",
    "get_povrsine",
    "get_pos_status_u",
    "get_ordered_construction",
  ],
  mixins: [mixin],
  components: {
    "vue-intervencija": intervencija,
    "vue-materijal": materijal,
    "vue-next": next,
    "vue-list": list,
  },
  data: function () {
    return {
      app_math: app_math,
      settings: settings,
    };
  },
  computed: {
    getJson: function () {
      const json = [];
      for (const pozicija in this.main_data.pos_status.value) {
        if (
          pozicija != 10 &&
          pozicija != 13 &&
          this.main_data.pos_status.value.hasOwnProperty(pozicija) &&
          this.main_data.pos_status.value[pozicija].status == 1
        ) {
          const value = this.main_data.pos_status.value[pozicija];
          json.push({
            povrsina_sprata: this.get_povrsine.B["povrsina_jednog_sprata"].toFixed(2),
            pozicija: this.getTitle(pozicija),
            povrsina: this.get_povrsine.B[pozicija].toFixed(2),
            debljina: Math.round(value.bottom_debljina_izolacije * 100),
            materijali: this.main_data.app_country_materijal.data[value.top_image][
              value.bottom_image === "b" || value.bottom_image === "c" ? value.bottom_image : "b"
            ],
          });
        }
      }

      return JSON.stringify(json);
    },

    ctaFontSize: function() {
      if (this.main_data.loc_country.value == "gr") {
        return "2rem";
      }
      return false;
    },
  },

  methods: {
    get_energy_color(energy) {
      if (energy === "G") return "#d2171e";
      if (energy === "F") return "#ff400e";
      if (energy === "E") return "#fe7309";
      if (energy === "D") return "#f9a51a";
      if (energy === "C") return "#f9ea1a";
      if (energy === "B") return "#a9d82a";
      if (energy === "A") return "#2db46a";
      if (energy === "A+") return "#179249";
    },
    getTitle: function (key) {
      const elem = this.get_ordered_construction.find((value) => value.key == key);
      return elem.title;
    },
    startAgain: function () {
      window.location.reload();
    },
    getCurrencyIconUrl: function () {
      const icon_name = this.main_data.currency_icon.value;
      return require("../../assets/images/currency/" + icon_name + ".svg");
    },
  },
};
</script>
